export const toHexWithOpacity = (color: string, opacity: number) => {
  return `${color}${Math.floor(opacity * 255).toString(16)}`;
};
